<template>
  <div>
    <ConstructionFolder :currentConstruction="cloudConstructionInfo" v-if="$route.name === 'create-kokuban-detail'" />
    <router-view :currentConstruction="cloudConstructionInfo" />
  </div>
</template>

<script>
import store from '@/store'
export default {
  name: 'CreateKokubanFolder',
  components: {
    ConstructionFolder: () => import('@/components/cloud/CreKokuban/ConstructionFolder.vue')
  },
  props: {
    constructionList: Array
  },
  beforeRouteEnter(to, from, next) {
    const args = {
      cloud_construction_id: to.params.cloudConstructionId
    };
    store.dispatch('api/getCloudConstructionInfo', args).then(() => {
      if (store.getters['api/apiError']) {
        next(false);
        return;
      }
      next();
    })
  },
  computed: {
    cloudConstructionInfo() {
      return this.$store.getters['api/result/cloudConstructionInfo'];
    }
  },
}
</script>

<style scoped>
</style>